import abstractModel from '../../core/MercatelyModel';
import { MERCATELY_API } from '../../constants/AppConstants';

const resource = `${MERCATELY_API}/features`;

const model = abstractModel(resource);

model.getFeatures = async () => model.get();

export default model;
